import { render, staticRenderFns } from "./StackSection.vue?vue&type=template&id=f062a74e&scoped=true"
import script from "./StackSection.vue?vue&type=script&lang=js"
export * from "./StackSection.vue?vue&type=script&lang=js"
import style0 from "./StackSection.vue?vue&type=style&index=0&id=f062a74e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f062a74e",
  null
  
)

export default component.exports